import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'

import {getUserDetails, login, logout} from './noauth.service'

export const userKeys = {me: ['me'] as const}

export const useGetUserDetails = () =>
  useQuery({queryKey: userKeys.me, queryFn: getUserDetails, retry: false, staleTime: Infinity})

export const useLogin = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: login,
    onSuccess: () => qc.invalidateQueries({queryKey: userKeys.me}),
  })
}

export const useLogout = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      qc.clear()
    },
  })
}
